import { render } from "./sort-transfer-pickup.vue?vue&type=template&id=2b7b9a67"
import script from "./sort-transfer-pickup.vue?vue&type=script&lang=js"
export * from "./sort-transfer-pickup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__